<template>
  <div class="client">
    <div class="top-header">
      <router-link :to="{ name: 'brands_list' }">
        <v-btn icon>
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
      </router-link>
      {{ model.name }}
    </div>

    <div class="py-5 px-8 white">
      <v-tabs v-model="tab" color="#ff9c00">
        <v-tab class="text-capitalize">
          <span class="vlue-tab-span black--text">
            Edit Model
          </span>
        </v-tab>
        <!--        <v-tab class="text-capitalize">-->
        <!--          <span class="vlue-tab-span black&#45;&#45;text">Cards</span>-->
        <!--        </v-tab>-->
      </v-tabs>
      <v-divider class="my-4 divider-dashed" />
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <EditModel :modelProp="model" />
        </v-tab-item>
      </v-tabs-items>
    </div>
  </div>
</template>

<script>
import EditModel from "./EditModel";
import RestResourceModel from "../../api/apiModelService";
import RestResourceEngineModel from "../../api/apiEngineModelService";
// import ClientOrders from "./ClientOrders";
export default {
  components: { EditModel },
  data() {
    return {
      model: {
        name: ""
      },
      tab: null
    };
  },
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      RestResourceEngineModel.prototype
        .getModel(this.$route.params.id)
        .then(response => {
          this.model = response.data;
        })
        .catch(error => {
          throw error;
        });
    }
  }
};
</script>

<style>
.client .v-tabs-slider-wrapper {
  height: calc(100% - 10px) !important;
  top: 50%;
  transform: translateY(-50%);
  border: solid 2px var(--cpanel-primary-color);
  border-radius: 7px;
}

.client .v-tabs-slider-wrapper .v-tabs-slider {
  background-color: transparent !important;
}
</style>
